import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

//import devicesEn from "./assets/translations/Devices/enDevices.json";
//import devicesDe from "./assets/translations/Devices/deDevices.json";
import enTranslations from "./assets/translations/enTranslations.json";
import enRefactoredTranslations from "./assets/translations/refractored.json";
import deTranslations from "./assets/translations/deTranslations.json";

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  //.use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: "en",
    lng: process.env.REACT_APP_DEFAULT_LANGUAGE || "en-EN",
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        //translation: devicesEn,
        //translation: devicesEn,
        translation: enTranslations,
        refactored: enRefactoredTranslations,
      },

      de: {
        //translation: devicesDe,
        translation: deTranslations,
      },
    },
  });

export default i18n;
